export default __webpack_public_path__ + "static/media/Floor-Cleaners.a4d45ef8.jpg";